import { render } from "./WidgetsVisibles.vue?vue&type=template&id=085114a0&scoped=true"
import script from "./WidgetsVisibles.vue?vue&type=script&lang=js"
export * from "./WidgetsVisibles.vue?vue&type=script&lang=js"

import "./WidgetsVisibles.vue?vue&type=style&index=0&id=085114a0&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085114a0"]])

export default __exports__